import { Form } from './Form'
import { Header } from './Header'

const Step4 = {
  Header,
  Form,
}

export default Step4
